export const QUICK_REPLY_EMPTY_ERROR_MESSAGE = 'Answer cannot be empty';
export const QUICK_QUESTION_TEXT =
  'Create a quick question to send to your users';
export const SAVE_TO_ATTR_TEXT = 'Save to attribute';
